import React from 'react';
import './Taxis.css';

// Importing necessary components and utilities
import { PageTitle, Taxi } from '../../../components';
import { taxis } from '../../../constants';



const Taxis = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Taxis'} page={'Taxis'} />

      {/* Taxis section */}
      <section className='taxis'>

        {/* Taxi container */}
        <div className='box-container'>
          {/* Render each Taxi component */}
          {taxis.map((taxi) => {
            return(  
              <Taxi key={taxi.id} taxi={taxi} /> // Render a Taxi component for each Taxi
            )
          })
          }
        </div>

      </section>
    </>
  )
}

export default Taxis;